import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { NameValuePair } from './DimensionSelector';
import {
  SubdimensionsDialog,
  SubdimensionsDialogProps,
} from './SubdimensionsDialog';

export type DimensionEditorProps = {
  dimensionName: string;
  subdimensions: NameValuePair[];
  setSubdimensionDictionary: SubdimensionsDialogProps['setSubdimensionDictionary'];
  subdimensionDictionary: SubdimensionsDialogProps['subdimensionDictionary'];
  fieldPath: string;
};

export const DimensionEditor = (props: DimensionEditorProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Controller
      name={props.fieldPath}
      defaultValue={true}
      render={({ field }) => (
        <Grid container direction="row" spacing={2} alignItems="center">
          <Grid size={6}>
            <FormControlLabel
              label={props.dimensionName}
              control={
                <Checkbox
                  onChange={e => field.onChange(e.target.checked)}
                  checked={!!field.value}
                />
              }
            />
          </Grid>
          <Grid size={6}>
            <Button
              size="small"
              sx={{ height: 'fit-content' }}
              disabled={!field.value}
              onClick={() => setIsDialogOpen(true)}
            >
              Edit Subdimension Names
            </Button>
            <SubdimensionsDialog
              open={isDialogOpen}
              onClose={() => setIsDialogOpen(false)}
              subdimensionDictionary={props.subdimensionDictionary}
              setSubdimensionDictionary={props.setSubdimensionDictionary}
              dimensionName={props.dimensionName}
              subdimensions={props.subdimensions}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};
